import React from 'react';
import './About.css';

const services = [
  {
    title: "🧑‍💻 Web Development",
    description: "Responsive and SEO-friendly websites tailored for performance and design.",
  },
  {
    title: "📱 App Development",
    description: "Native and cross-platform mobile apps from concept to deployment.",
  },
  {
    title: "📊 Data Science & Analytics",
    description: "Training on real datasets with Python, ML, and business insights.",
  },
  {
    title: "🎨 Graphic Design",
    description: "UI/UX, branding, social media creatives, posters and more.",
  },
  {
    title: "📣 Digital Marketing",
    description: "Learn ad campaigns, SEO, content marketing, and analytics tools.",
  },
  {
    title: "🖥️ Full-Stack Development",
    description: "MERN stack internships with live deployment and Git mastery.",
  },
  {
    title: "🔒 Cybersecurity",
    description: "Ethical hacking basics, secure coding practices, and risk assessment.",
  },
  {
    title: "📷 Video Editing & Animation",
    description: "Motion graphics, editing reels, and visual storytelling.",
  },
  {
    title: "🤖 AI & Machine Learning",
    description: "Build ML models, AI apps, and integrate with APIs like OpenAI.",
  },
  {
    title: "🛰️ Cloud & DevOps",
    description: "CI/CD pipelines, Docker, Kubernetes, AWS and deployment workflows.",
  },
];

const testimonials = [
  {
    name: "Riya Sharma",
    quote: "The internship was hands-on and helped me land my first developer job!",
  },
  {
    name: "Aman Patel",
    quote: "Real-world projects and mentorship made this experience amazing.",
  },
];

const techStack = [
  "React", "Node.js", "MongoDB", "Python", "Figma", "AWS", "Docker", "GitHub"
];

const About = () => {
  return (
    <main className="about-page">
      <h1>About Us</h1>

      <section className="intro">
        <p>
  We are an IT services company offering cutting-edge solutions across web development, app development, AI/ML, data science, cybersecurity, Java, and Power BI. Backed by a team of freelancers and partnered firms like <strong>PcmcCait Pvt. Ltd.</strong> and <strong>Jm-Tech Solutions Ahmedabad</strong>, we deliver tailored, reliable, and scalable digital services.
        </p>
      </section>

      <section className="cards-grid">
        {services.map((item, index) => (
          <div className="about-card" key={index}>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </section>

      <section className="why-us">
  <h2>🌟 Why Choose Us?</h2>
  <ul>
    <li>✅ Industry-experienced mentors guiding your journey</li>
    <li>🎓 Project-based, certified learning for real-world skills</li>
    <li>💻 Flexible formats: Online & Offline for your convenience</li>
    <li>📁 Live projects hosted on GitHub & cloud platforms</li>
    <li>🚀 Career-launching roadmap tailored to your goals</li>
  </ul>
</section>


      

     
      <section className="call-to-action">
        <h2>Ready to Level Up?</h2>
        <p>Join our internship programs today and build your future with confidence.</p>
       
      </section>
    </main>
  );
};

export default About;
